<template>
  <!-- Gallery List View -->
  <div class="text-uppercase col-8 offset-2 p-5">
  <!-- Lade Gallerie-Kategorien aus dem Store   -->
    <div class="d-inline-block" v-for="(category, index) in cat" :key="'cat-'+ index">
      <div class="gallery_link">
        <img
                :src="$store.state[category.name]['previews'][getRandI(category.name)]" style="max-width:300px; max-height:200px" >

        <router-link :to="{name: 'galleryview', params: {view: category.name, title:category.title}}"><div class="overlay p-3">
          <div class="overlay_text ">{{category.title}}</div>
        </div>
        </router-link>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: "Gallery",
    data(){
      return {
        cat: null,
      }
    },
    methods: {
      /**
       *
       * @param category
       * @returns {number} random image from category preview array
       */
      getRandI(category) {
        return Math.floor(Math.random() * this.$store.state[category]['previews'].length)
      }
     },
    created() {
      this.cat = this.$store.state.categories;
    }

  }
</script>

<style scoped lang="scss">
  .image {
    float: left;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border: 1px solid #ebebeb;
    margin: 5px;
  }
  .overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    opacity: 0;
    transition: .25s ease;
    background-color: #000000;
  }
  .gallery_link {
    position: relative;
    display: inline-block;
    width: 200px;
    height: 200px;
    overflow: hidden;
    margin-left: 5px;
    img {
      border: 1px solid #DDDDDD;
      padding: 5px;
      box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
      margin: 0 10px 10px 0;
      position: relative;
      display:inline-block;
      background-color: white;
      vertical-align: middle;
      -webkit-transition: all .3s;
      border-radius: 2px;
      text-decoration: none;
      cursor: pointer;
      transition: transform .5s ease;
    }
    &:hover img{
      transform: scale(1.2);
      filter: grayscale(100%);
    }
    &:hover .overlay  {
      opacity: .85;
    }
  }

  .overlay_text {
    color: white;
    font-size: 18px;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    text-align: center;
  }
</style>